<template>
  <div class="hr-check">
    <co-checkbox
      class="hr-check__box"
      data-test-id="hr-check-box"
      v-model="state.theValue"
      @change="change"
      >{{ label }}</co-checkbox
    >

    <div class="hr-check__helper">{{ helper }}</div>
    <div v-if="errorMessage" class="hr-check__error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue';
import { CoCheckbox } from '@deputy/copilot2';
export default {
  name: 'hr-check',
  components: { CoCheckbox },
  props: {
    label: {
      type: String,
      default: null,
    },
    helper: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },
  emits: ['input'],
  setup(props, { emit }) {
    const state = reactive({
      theValue: props.value,
    });
    function change() {
      emit('input', state.theValue);
    }
    return {
      state,
      change,
    };
  },
};
</script>

<style scoped lang="scss">
@import '@/core/style-vars.scss';

.hr-check__error {
  color: var(--co-status-red);
}

.hr-check .co-checkbox {
  font-weight: normal;
  background-color: var(--co-background-secondary);
  border-radius: 8px;
  padding: 20px;
  display: flex;
  margin-bottom: 10px;
  white-space: normal;
}
.hr-check :deep(.co-checkbox__input) {
  margin-right: 10px;
}
.hr-check :deep(.co-checkbox__inner) {
  width: 20px;
  height: 20px;
}
.hr-check :deep(.co-checkbox__inner)::after {
  height: 10px;
  transform-origin: center;
  width: 4px;
  transform: translate(25%, 10%) rotate(45deg) scaleY(1) !important;
  border-width: 2px;
}

@media only screen and (max-width: 768px) {
  .hr-check__error {
    font-size: 16px;
  }
}
</style>
